<template lang="pug">
  div
    div.container-fluid(style="margin-top:15px;")
      div.row.justify-content-center
        div.col-12.col-md-11.col-lg-10
          div.row.justify-content-center
            div.col-12.col-sm-6(v-show="reset.status==0")
              div.row.justify-content-center
                div.col-11.form-colored
                  form
                    h4 パスワード再発行
                    hr.hr15
                    hr.hr15
                    input(v-model="email", :class="issue_fail? 'form-control is-invalid':'form-control'", type="text", style="width:90%; margin: auto;", placeholder="Email", required="required", autofocus="")
                    hr.hr20
                    hr.hr20
                    button.btn.btn-primary(type="button", style="width:90%;", @click="issue_token", :disabled="!email") 再発行をリクエスト
                    p.text-danger(v-show="issue_fail", style="margin-top: 10px; margin-bottom: 0px;") このEmailは登録されていません。
                    p(v-show="issue_success")
                      | パスワード再設定メールを送信しました。
                      br
                      | メール記載のURLより、24時間以内にパスワードを再設定してください。
            div.col-12.col-sm-6(v-show="reset.status==400")
              div.row.justify-content-center
                div.col-11.form-colored
                  form
                    h4 URLが不正、または期限切れです。
            div.col-12.col-sm-6(v-if="reset.status==200")
              div.row.justify-content-center
                div.col-11.form-colored
                  form
                    h4 パスワード再発行
                    hr.hr15
                    input.form-control(v-model="reset.email", type="text", style="width:90%; margin: auto;", disabled)
                    hr.hr15
                    input.form-control(v-model="reset.password", type="password", style="width:90%; margin: auto;", placeholder="Password", required="required", autofocus="", v-show-password-input)
                    hr.hr20
                    button.form-control.btn.btn-primary(type="button", style="width:90%;", @click="reset_password", :disabled="!reset.password") 再設定する
                    p.text-danger(v-show="reset_fail", style="margin-top: 10px; margin-bottom: 0px;") 再設定できませんでした。
                    p(v-show="reset_success") 再設定が完了しました。
                    a.btn.btn-info(v-show="reset_success", href="/login") ログイン画面へ




</template>

<script>

export default {
  name: 'ForgotPassword',
  components: {
  },
  head: {
    title: {
      inner: 'Password'
    },
    meta: [
      { name:"description", content:""}
    ]
  },
  data (){
    return {
      email:"",
      issue_fail:false,
      issue_success:false,
      reset_fail:false,
      reset_success:false,
      reset:{
        status:-1,
        email:"",
        password:""
      }
    }
  },
  created (){
    if("token" in this.$route.query){
      this.$axios.get("api/forgotpass?token="+this.$route.query.token)
      .then((response) => {
        this.reset = response.data;
      })
      .catch((error) => {
        this.reset.status = 400;
      });
    }
    else
      this.reset.status = 0;
  },
  mounted (){

  },
  methods:{
    issue_token (e){
      this.issue_fail = false;
      this.issue_success = false;
      let btn = e.target;
      btn.disabled = true;
      btn.innerHTML = '処理中<div class="loader-inner ball-pulse" style="display: inline-block; vertical-align: sub; padding-left:14px;"><div></div><div></div><div></div></div>';
      var data = {
        email:this.email
      };
      this.$axios.post("api/forgotpass", data)
      .then((response) => {
        btn.hidden = true;
        this.issue_success = true;
      })
      .catch((error) => {
        btn.disabled = false;
        btn.innerHTML = '再発行をリクエスト';
        this.issue_fail = true;
      });
    },
    reset_password (e){
      this.reset_fail = false;
      this.reset_success = false;
      let btn = e.target;
      btn.disabled = true;
      btn.innerHTML = '処理中<div class="loader-inner ball-pulse" style="display: inline-block; vertical-align: sub; padding-left:14px;"><div></div><div></div><div></div></div>';
      var data = {
        token: this.$route.query.token,
        password: this.reset.password
      };
      this.$axios.post("api/forgotpass", data)
      .then((response) => {
        btn.hidden = true;
        this.reset_success = true;
      })
      .catch((error) => {
        btn.disabled = false;
        btn.innerHTML = '再設定する';
        this.reset_fail = true;
      });

    }
  }
}
</script>

<style scoped>

.hr15 {
  height: 15px;
  border: none;
  margin: 0px;
  padding: 0px;
  width: 100%;
}

.hr20 {
  height: 20px;
  border: none;
  margin: 0px;
  padding: 0px;
  width: 100%;
}

.form-colored {
  background-color: rgb(247, 250, 252);
  box-shadow: 0 4px 6px rgba(50,50,93,.11), 0 1px 3px rgba(0,0,0,.08);
  padding: 20px;
  height: 300px;
}


</style>
